import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';
import { compose } from 'redux';

import { Button, Checkbox } from '@pearsontechnology/aero-components';

import { featureKeys } from 'services/FeatureFlagService';
import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';
import { ModalActions } from 'components/Modal';
import { publishFormat } from '../../utils/constants';

import messages from './messages';
import {
  AddModalWrapper,
  OutputTypeItem,
  ModalTitle,
} from './styles';
import enhanceWithFeatureFlagSubscription from 'hocs/enhanceWithFeatureFlagSubscription';

let outputOptions = [
  { type: publishFormat.EPUB, label: messages.EPUB_ETEXT },
  { type: publishFormat.PEARSON_PLUS, label: messages.BRONTE_PEARSON_PLUS },
  { type: publishFormat.CHANNEL_PARTNER, label: messages.EPUB_CHANNEL_PARTNER },
  { type: publishFormat.IN_DESIGN, label: messages.IN_DESIGN },
  { type: publishFormat.CLASS_ON_DEMAND, label: messages.BRONTE_CLASSES_ON_DEMAND },
  { type: publishFormat.PEARSON_PLUS_TEST, label: messages.BRONTE_PEARSON_PLUS_TEST_ONLY },
];

const getFormatLabels = (isChannelPartnerOutputTypeEnabled, isPearsonPlusOutputTypeEnabled, isClassOnDemandOutputTypeEnabled, isPearsonPlusTestOutputTypeEnabled, isIndesignOutputTypeEnabled) => {
  if (!isChannelPartnerOutputTypeEnabled) {
    outputOptions = outputOptions.filter((item) => item.type !== publishFormat.CHANNEL_PARTNER);
  }
  if (!isClassOnDemandOutputTypeEnabled) {
    outputOptions = outputOptions.filter((item) => item.type !== publishFormat.CLASS_ON_DEMAND);
  }
  if (!isPearsonPlusOutputTypeEnabled) {
    outputOptions = outputOptions.filter((item) => item.type !== publishFormat.PEARSON_PLUS);
  }
  if (!isPearsonPlusTestOutputTypeEnabled) {
    outputOptions = outputOptions.filter((item) => item.type !== publishFormat.PEARSON_PLUS_TEST);
  }
  if (!isIndesignOutputTypeEnabled) {
    outputOptions = outputOptions.filter((item) => item.type !== publishFormat.IN_DESIGN);
  }
  return outputOptions;
};

function PublishOutputType({ onDismiss, setPublicationOutputType, getFeatureFlagValue }) {
  const isChannelPartnerOutputTypeEnabled = getFeatureFlagValue(featureKeys.WORKSPACE_PUBICATION_OUTPUT_TYPE_CHANNEL_PARTNER);
  const isPearsonPlusOutputTypeEnabled = getFeatureFlagValue(featureKeys.WORKSPACE_PUBLICATIONS_PEARSON_PLUS_ETEXT);
  const isClassOnDemandOutputTypeEnabled = getFeatureFlagValue(featureKeys.WORKSPACE_PUBLICATIONS_CLASSONDEMAND);
  const isPearsonPlusTestOutputTypeEnabled = getFeatureFlagValue(featureKeys.WORKSPACE_PUBLICATIONS_BV_TEST_ONLY);
  const isIndesignOutputTypeEnabled = getFeatureFlagValue(featureKeys.WORKSPACE_PUBLICATIONS_INDESIGN);
  const formatLabels = getFormatLabels(isChannelPartnerOutputTypeEnabled, isPearsonPlusOutputTypeEnabled, isClassOnDemandOutputTypeEnabled, isPearsonPlusTestOutputTypeEnabled, isIndesignOutputTypeEnabled);
  const [formatSelected, setFormatSelected] = useState(publishFormat.EPUB);

  const onNext = () => {
    setPublicationOutputType(formatSelected);
  };

  const selectNewOutputType = (outputFormatItem) => {
    setFormatSelected(outputFormatItem.type);
  };

  const checkBoxes = formatLabels.map((item, i) => 
    <OutputTypeItem key={i}>
      <Checkbox label={intl.formatMessage(item.label)} 
        rounded
        checked={formatSelected === item.type}
        onChange={()=>selectNewOutputType(item)}
      />
    </OutputTypeItem>);

  return (
    <AddModalWrapper>
      <ModalTitle>{intl.formatMessage(messages.outputSelectTitle)}</ModalTitle>
      {checkBoxes}
      <ModalActions>
        <Button grey onClick={onDismiss}>{intl.formatMessage(messages.cancelButton)}</Button>
        <Button primary onClick={onNext}>{intl.formatMessage(messages.nextButton)}</Button>
      </ModalActions>
    </AddModalWrapper> 
  );
}

PublishOutputType.propTypes = {
  onDismiss: PropTypes.func,
  onAddPublicationOutputType: PropTypes.func,
};

const flagNames = [
  featureKeys.WORKSPACE_PUBICATION_OUTPUT_TYPE_CHANNEL_PARTNER,
  featureKeys.WORKSPACE_PUBLICATIONS_PEARSON_PLUS_ETEXT,
  featureKeys.WORKSPACE_PUBLICATIONS_CLASSONDEMAND,
  featureKeys.WORKSPACE_PUBLICATIONS_BV_TEST_ONLY,
  featureKeys.WORKSPACE_PUBLICATIONS_INDESIGN,
];

export default compose(withTheme, enhanceWithFeatureFlagSubscription)(PublishOutputType, flagNames);
